import React, { lazy, Suspense, useState, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Preloader from "../Components/Preloader/Preloader";
import { Header } from "../Components/Header/Header";
import { ViewMore } from "./ViewMore";
import { ShareProfile } from "./ViewMore/ShareProfile";
import { UserprofileEdit } from "./userprofileEdit";
import { AddProfile } from "./useraddProfile/index";
import { MatchmakerProfileEdit } from "./MatchmakerProfileEdit";
import { Login } from "./Login/Login";
import { Otp } from "./Otp/otp";
import { Signup } from "./Signup/Signup";
import { Transactions } from "./Transactions";
import { ViewProfile } from "./ViewMore/ViewProfile";
import { SharePublic } from "./ViewMore/SharePublic";
import { PaymentSuccess } from "./Home/PaymentSuccess";
import { PaymentFailed } from "./Home/PaymentFailed";
import { ContactUs } from "./ContactUs/ContactUs";
import { OnBoardProfile } from "./Home/OnBoardProfile";
import { Redeem } from "./Home/Redeem";
import { RequestProfileView } from "./Transactions/RequestProfileView";

// {Layout}


const Home = lazy(() => import("./Home"));

export const Layout = () => {
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const tempToken = localStorage.getItem("temp_token");

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const location = useLocation();

  const isAuthPage =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/otp" ||
    location.pathname === "/signup" ||
    location.pathname === "/payment-success" ||
    location.pathname === "/payment-failed" ||
    location.pathname.startsWith("/share-profile/") ||
    location.pathname.startsWith("/share-public-profile/") ||
    location.pathname.startsWith("/onboard/");

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <div>
          {!isAuthPage && <Header />}
          <main>
            <Suspense fallback={<Preloader />}>
              <Routes>
                {/* Redirect to home if token is present */}
                <Route
                  path="/"
                  element={token ? <Navigate to="/home" /> : <Login />}
                />
                <Route
                  path="/login"
                  element={token ? <Navigate to="/home" /> : <Login />}
                />
                <Route
                  path="/signup"
                  element={
                    token && tempToken ? (
                      <Signup />
                    ) : token ? (
                      <Navigate to="/home" />
                    ) : (
                      <Navigate to="/login" />
                    )
                  }
                />

                <Route
                  path="/otp"
                  element={token ? <Navigate to="/home" /> : <Otp />}
                />

                {/* Publicly accessible pages */}
                <Route
                  path="/share-public-profile/:publicToken/:name"
                  element={<SharePublic />}
                />
                <Route path="/share-profile/:id" element={<ShareProfile />} />
                <Route
                  path="/onboard/:publicToken/:name/:agencyNameUser"
                  element={<OnBoardProfile />}
                />

                {token ? (
                  <>
                    <Route path="/home" element={<Home />} />
                    <Route path="/view-more" element={<ViewMore />} />
                    <Route path="/view-profile" element={<ViewProfile />} />
                    <Route path="/trasactions" element={<Transactions />} />
                    <Route
                      path="/edit-profile/:id"
                      element={<UserprofileEdit />}
                    />
                    <Route path="/add-profile" element={<AddProfile />} />
                    <Route
                      path="/matchmaker-profile-edit"
                      element={<MatchmakerProfileEdit />}
                    />
                    <Route
                      path="/payment-success"
                      element={<PaymentSuccess />}
                    />
                    <Route path="/payment-failed" element={<PaymentFailed />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/redeem" element={<Redeem />} />
                    <Route
                      path="/request-profile-view/:id"
                      element={<RequestProfileView />}
                    />
                  </>
                ) : (
                  <Route path="*" element={<Navigate to="/login" />} />
                )}

                {/* Catch-all route */}
                <Route path="*" element={<div>Page not found</div>} />
              </Routes>
            </Suspense>
          </main>
        </div>
      )}
    </>
  );
};
